import React, { useMemo, useState } from 'react';
import getDefaultRecipeImage from '../utils/defaultRecipeImages';

const SignedImage = ({ src, alt, className = '', fallback, category, defaultCategory }) => {
    const [error, setError] = useState(false);

    const fallbackSrc = useMemo(() => {
        const categoryForFallback = category || defaultCategory;
        return getDefaultRecipeImage(categoryForFallback);
    }, [category, defaultCategory]);

    if ((error || !src) && fallback) {
        return fallback;
    }

    const resolvedSrc = (!src || error) ? fallbackSrc : src;

    return (
        <img
            src={resolvedSrc}
            alt={alt || 'Recipe image'}
            className={className}
            onError={() => {
                if (!error) {
                    setError(true);
                }
            }}
            loading="lazy"
        />
    );
};

export default SignedImage;
